import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_PAGINATED_EVENT_REPORTS = 'GET_PAGINATED_EVENT_REPORTS';
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const UNSET_CURRENT_EVENT = 'UNSET_CURRENT_EVENT';

// async actions
export const GETTING_PAGINATED_EVENT_REPORTS = 'GETTING_PAGINATED_EVENT_REPORTS';
export const GETTING_PAGINATED_EVENT_REPORTS_SUCCEEDED =
  'GETTING_PAGINATED_EVENT_REPORTS_SUCCEEDED';
export const GETTING_PAGINATED_EVENT_REPORTS_FAILED =
  'GETTING_PAGINATED_EVENT_REPORTS_FAILED';

export const CLEAR_EVENT_REPORTS_STORE = 'CLEAR_EVENT_REPORTS_STORE';

export const GET_PAGINATED_EVENT_HISTORY = 'GET_PAGINATED_EVENT_HISTORY';
export const GETTING_PAGINATED_EVENT_HISTORY_SUCCEEDED = 'GETTING_PAGINATED_EVENT_HISTORY_SUCCEEDED';

export const GET_EVENT_REPORT_CSV_FILE = 'GET_EVENT_REPORT_CSV_FILE';
export const GETTING_EVENT_REPORT_CSV_FILE_SUCCEEDED = 'GETTING_EVENT_REPORT_CSV_FILE_SUCCEEDED';
export const GETTING_EVENT_REPORT_CSV_FILE_FAILED = 'GETTING_EVENT_REPORT_CSV_FILE_FAILED';
export const DOWNLOADED_EVENT_REPORT_CSV_FILE = 'DOWNLOADED_EVENT_REPORT_CSV_FILE';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const UPDATE_EVENT_REPORT_FILTERS = 'UPDATE_EVENT_REPORT_FILTERS';
export const RESET_EVENT_REPORT_FILTERS = 'RESET_EVENT_REPORT_FILTERS';
export const UPDATE_EVENT_IDENTIFIER_FILTER = 'UPDATE_EVENT_IDENTIFIER_FILTER';

export const GET_EVENT_LOG = 'GET_EVENT_LOG';
export const GETTING_EVENT_LOG_SUCCEEDED = 'GETTING_EVENT_LOG_SUCCEEDED';
export const GETTING_EVENT_LOG_FAILED = 'GETTING_EVENT_LOG_FAILED';

export const getPaginatedEventReports = createAction(GET_PAGINATED_EVENT_REPORTS);

export const gettingPaginatedEventReports = createAction(GETTING_PAGINATED_EVENT_REPORTS);
export const gettingPaginatedEventReportsSucceeded = createAction(
  GETTING_PAGINATED_EVENT_REPORTS_SUCCEEDED
);
export const gettingPaginatedEventReportsFailed = createAction(
  GETTING_PAGINATED_EVENT_REPORTS_FAILED
);

export const clearEventReportsStore = createAction(CLEAR_EVENT_REPORTS_STORE);
export const setCurrentEvent = createAction(SET_CURRENT_EVENT);
export const unsetCurrentEvent = createAction(UNSET_CURRENT_EVENT);

export const getPaginatedEventHistory = createAction(GET_PAGINATED_EVENT_HISTORY);
export const gettingPaginatedEventHistorySucceeded = createAction(GETTING_PAGINATED_EVENT_HISTORY_SUCCEEDED);

export const getEventReportCsvFile = createAction(GET_EVENT_REPORT_CSV_FILE);
export const gettingEventReportCsvFileSucceeded = createAction(GETTING_EVENT_REPORT_CSV_FILE_SUCCEEDED);
export const gettingEventReportCsvFileFailed = createAction(GETTING_EVENT_REPORT_CSV_FILE_FAILED);
export const downloadedEventReportCsvFile = createAction(DOWNLOADED_EVENT_REPORT_CSV_FILE);
export const resetSnackbar = createAction(RESET_SNACKBAR);

export const updateEventReportFilters = createAction(UPDATE_EVENT_REPORT_FILTERS);
export const resetEventReportFilters = createAction(RESET_EVENT_REPORT_FILTERS);
export const updateEventIdentifierFilter = createAction('UPDATE_EVENT_IDENTIFIER_FILTER');

export const getEventLog = createAction(GET_EVENT_LOG);
export const gettingEventLogSucceeded = createAction(GETTING_EVENT_LOG_SUCCEEDED);
export const gettingEventLogFailed = createAction(GETTING_EVENT_LOG_FAILED);